import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-total-record-count',
  templateUrl: './total-record-count.component.html',
  styleUrls: ['./total-record-count.component.scss']
})
export class TotalRecordCountComponent implements OnInit {

  @Input() name = '';
  @Input() count = 0;

  constructor() { }

  ngOnInit(): void { }

}
